// Reducer spécialisé pour la gestion du service
import { MatchState, MatchAction } from '../../types';

export function handleServingActions(state: MatchState, action: MatchAction): MatchState | null {
  switch (action.type) {
    case 'SET_SERVING_PLAYER':
      return {
        ...state,
        servingPlayer: action.player,
        servingSide: null,
        canChangeServingSide: true,
        pendingDecisionLineIndex: null
      };
    
    case 'SET_SERVING_SIDE':
      const updatedState = {
        ...state,
        servingSide: action.side
      };

      // ✅ Démarrer les timers si c'est le premier service
      if (state.matchStartTime === null && action.side) {
        updatedState.matchStartTime = Date.now();  // Premier service du match
      }
      if (state.gameStartTime === null && action.side) {
        updatedState.gameStartTime = Date.now();   // Premier service du jeu
      }
      
      // Si on a une ligne de décision en cours de completion
      if (state.pendingDecisionLineIndex !== null) {
        const updatedPointsTable = [...state.pointsTable];
        const lineToUpdate = updatedPointsTable[state.pendingDecisionLineIndex];

        // Compléter la ligne avec le côté choisi
        updatedPointsTable[state.pendingDecisionLineIndex] = {
          ...lineToUpdate,
          servingSide: action.side
        };
        updatedState.pointsTable = updatedPointsTable;
        updatedState.pendingDecisionLineIndex = null; // Ligne maintenant complète
      }
      // Mettre à jour la dernière entrée du tableau
      // (permet de changer de côté à tout moment avant de marquer le prochain point)
      else if (state.pointsTable.length > 0 && action.side) {
        const lastEntry = state.pointsTable[state.pointsTable.length - 1];
        // Mettre à jour si la dernière entrée appartient au serveur actuel
        if (lastEntry.servingPlayer === state.servingPlayer) {
          const updatedPointsTable = [...state.pointsTable];
          updatedPointsTable[updatedPointsTable.length - 1] = {
            ...lastEntry,
            servingSide: action.side
          };
          updatedState.pointsTable = updatedPointsTable;
        }
      }
      
      return updatedState;
    
    default:
      return null; // Action non gérée par ce reducer
  }
}